import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionEntryForm from '../../../components/forms/CompetitionEntryForm';
import { useCompetitionEntryApi } from '../../../hooks/useCompetitionEntryApi';
import { useNavigate } from 'react-router-dom';
import { CompetitionEntryDTO } from '../../../services/apiClient';

const CompetitionEntryCreate: React.FC = () => {
  const { create, isLoading } = useCompetitionEntryApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Entries', href: '/admin/competitionentries' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionEntryDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/competitionentries');
    } catch (error) {
      console.error('Error creating CompetitionEntry:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionentries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['User']}
      requiredPermission='Manage.CompetitionEntry.Edit'
    >
        <CompetitionEntryForm
          initialValues={{} as CompetitionEntryDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionentries')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default CompetitionEntryCreate;